import React from "react";

export interface AuthContextProps {
  logout: () => Promise<void>;
}

export const AuthContext = React.createContext<AuthContextProps>({
  logout: () => Promise.resolve()
});
